/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography, Avatar } from '@mui/material';
import { fonts, themes } from '../../../common/themes/themes';
import './Attendance.css';

import TimeSheetController from '../../../domain/myProfile/attendance/Timesheet/TimeSheetController';
import AttendanceCalendarController from '../../../domain/myProfile/attendance/AttendanceCalendar/AttendanceCalendarController';
import WeekoffNtimeShiftController from '../../../domain/myProfile/attendance/Week-off&TimeShift/WeekoffNtimeShiftController';
import { useAppSelector } from '../../../infra/hooks';

interface attendanceProp {
  trans?: any;
  i18n?: any;
  empProfilePic?: any;
  empName?: any;
  empDesignation?: any;
}
const AttendancePresenter = ({
  trans,
  i18n,
  empName,
  empProfilePic,
  empDesignation,
}: attendanceProp) => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);
  const isOnlyAttendanceView = useAppSelector(
    (state) => state.isHRViewSlice.isOnlyAttendanceView,
  );

  const getMarginLeftValue = () => {
    if (isHRView && i18n.language == 'en' && !isOnlyAttendanceView) {
      return '11em';
    } else if (!isHRView && i18n.language == 'en' && !isOnlyAttendanceView) {
      return '14em';
    } else if (isOnlyAttendanceView) {
      return '';
    } else {
      return '';
    }
  };

  return (
    <Grid
      container
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        marginTop: isHRView ? '' : '4em',
        width: '100vw',
        paddingRight: '8em',
      }}
    >
      <Grid
        item
        xs={11}
        sm={11}
        md={11}
        lg={11}
        sx={{
          backgroundColor: '#F5F5FA',
          width: '100%',
          padding: '1.75em',
          marginLeft: getMarginLeftValue(),
          marginRight: i18n.language == 'ar' ? '15em' : '',
          overflowY: 'auto',
        }}
      >
        <Grid
          container
          style={{
            paddingLeft: isHRView ? '2em' : '',
          }}
        >
          <Grid
            item
            sx={{
              width: '100%',
              height: '80px',
            }}
          >
            <Grid
              container
              style={{
                width: 'auto',
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                borderRadius: '10px',
                opacity: '1',
                display: 'flex',
                flexDirection: 'row',
                paddingTop: '1em',
                paddingBottom: '1em',
                paddingLeft: '1em',
                paddingRight: '1em',
              }}
            >
              <Grid item xs={9}>
                {isOnlyAttendanceView ? (
                  <Box style={{ display: 'flex' }}>
                    <Avatar
                      src={empProfilePic}
                      style={{
                        width: '3em',
                        height: '3em',
                      }}
                    />
                    <Typography
                      style={{
                        fontFamily: fonts.fontFamily,
                        color: themes.blackDefault,
                        fontWeight: 'bold',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: '1em',
                      }}
                    >
                      <span
                        style={{
                          fontSize: fonts.title,
                        }}
                      >
                        {empName}
                      </span>
                      <span
                        style={{
                          color: themes.greyDefault_500,
                          fontSize: fonts.subtitle,
                        }}
                      >
                        {empDesignation}
                      </span>
                    </Typography>
                  </Box>
                ) : (
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.header,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Attendance')}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={12}></Grid>
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <WeekoffNtimeShiftController />
                <Box style={{ marginTop: '1.75em' }} />
                <AttendanceCalendarController />
              </Grid>
              <Grid item xs={8} sm={8} md={8} lg={8}>
                <TimeSheetController />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default AttendancePresenter;
